import api from '@/services/api';
import { handleException } from '@/utils/exception';
import { toast } from 'react-toastify';

import { type BasicUnit, type Unit } from '../types';

const BASE_URL = 'units';

export const getUnits = async () => {
  return await api.get<Unit[]>(BASE_URL);
};

export const getBasicUnit = async () => {
  return await api.get<BasicUnit[]>(`${BASE_URL}/basic`);
};

export const getUnit = async (id: number) => {
  return await api.get<Unit>(`${BASE_URL}/${id}`);
};

export const updateUnit = async (data: Unit) => {
  try {
    await api.put(BASE_URL, data);
    toast.success('Unit updated successfully');
    return data;
  } catch (e) {
    toast.error(handleException(e, 'Failed to update Unit'));
    throw e;
  }
};

export const createUnit = async (data: Unit) => {
  try {
    await api.post(BASE_URL, data);
    toast.success('Unit created successfully');
    return data;
  } catch (e) {
    toast.error(handleException(e, 'Failed to create Unit'));
    throw e;
  }
};

export const deleteUnit = async (id: number) => {
  try {
    await api.delete(`${BASE_URL}/${id}`);
    toast.success('Unit deleted successfully');
  } catch (e) {
    toast.error(handleException(e, 'Failed to delete Unit'));
    throw e;
  }
};
